import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute right-0 top-0 z-1 mt-20 px-10 pt-3 pb-2 bg-black text-white not-italic o-text-caption md:right-auto md:left-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProductImage, {
      sku: _ctx.variant.sku,
      alt: _ctx.variant.name,
      "width-on-screen": 20,
      class: _normalizeClass({'opacity-35': _ctx.variant.isDiscontinued}),
      "cache-bust": _ctx.variant.imageVersion
    }, null, 8, ["sku", "alt", "class", "cache-bust"]),
    (_ctx.variant.isDiscontinued)
      ? (_openBlock(), _createElementBlock("em", _hoisted_1, _toDisplayString(_ctx.labels.lineItemDiscontinued), 1))
      : _createCommentVNode("", true)
  ]))
}